const newsBanner = document.querySelector('.news-banner');
const removeNewsBanner = document.querySelector('.remove-news-banner');
const heroContentDisplay = document.querySelector('#heroContentDisplay');
const pageContent = document.getElementById('page-content');

const NEWS_BANNER_TEXT_STORAGE_KEY = 'confirmedNewsBannerText';

function getNewsBannerText() {
	return newsBanner.getAttribute('data-news-banner-description') || '';
}

function getPreviousNewsBannerText() {
	try {
		return localStorage.getItem(NEWS_BANNER_TEXT_STORAGE_KEY);
	} catch (_) {}
}

function setCurrentNewsBannerText(currentDescription) {
	try {
		localStorage.setItem(NEWS_BANNER_TEXT_STORAGE_KEY, currentDescription);
	} catch (_) {}
}

if (newsBanner) {
	const currentDescription = getNewsBannerText();
	const previousDescription = getPreviousNewsBannerText();

	if (previousDescription && previousDescription === currentDescription) {
		newsBanner.classList.add('hidden');
		reduceContentMargin();
	} else {
		newsBanner.classList.remove('hidden');
	}
}

function reduceContentMargin() {
	if (pageContent && window.matchMedia('(max-width: 768px)').matches) {
		pageContent.classList.remove('mt-39', 'sm:mt-35');
		pageContent.classList.add('mt-20', 'sm:mt-30');
	}
}

if (removeNewsBanner) {
	removeNewsBanner.addEventListener('click', () => {
		const currentDescription = getNewsBannerText();
		setCurrentNewsBannerText(currentDescription);

		newsBanner.classList.add('hidden');
		reduceContentMargin();
		if (heroContentDisplay) {
			heroContentDisplay.classList.remove('mt-12', 'sm:mt-4');
			heroContentDisplay.classList.add('-mt-3', 'sm:mt-0');
		}
	});
}

const mediaQuery = window.matchMedia(
	'(max-width: 767px) and (max-height: 800px)',
);
function updateHeroSpacing() {
	if (!heroContentDisplay) {
		return;
	}

	const isBannerHidden = newsBanner?.classList.contains('hidden');
	if (!isBannerHidden && mediaQuery.matches) {
		heroContentDisplay.classList.remove('-mt-3', 'sm:mt-0');
		heroContentDisplay.classList.add('mt-12', 'sm:mt-4');
	} else {
		heroContentDisplay.classList.remove('mt-12', 'sm:mt-4');
		heroContentDisplay.classList.add('-mt-3', 'sm:mt-0');
	}
}

mediaQuery.addEventListener('change', updateHeroSpacing);
updateHeroSpacing();
